import Param from '../../param';
import effectManager from '../effect';
import AnimationMnager from '../animation';
import ModalSet from './modalSet';
import ModalOpen from './modalOpen';
import ModalClose from './modalClose';
import ModalListCarousel from './modalListCarousel';

const param = new Param();
const effect = new effectManager();
const animation = new AnimationMnager();

/* ---------------------------------------

    -- コラムのモーダル周りを制御

--------------------------------------- */

export default class ModalManager{
    constructor(){
        this.$container = $("#p-column-modal");
        this.$list =  $("#p-column-list");
        this.$trigger =  this.$list.find(".js__modal-trigger");

        this.$modalCnt =  $("#p-column-modal-body .modal-cnt");
        this.$modalPage =  $("#p-column-modal-body-page");
        this.$modalNext = $("#p-column-modal-body-ctrl-next,#p-column-modal-body-page .next");
        this.$modalPrev = $("#p-column-modal-body-ctrl-prev,#p-column-modal-body-page .prev");


        this.set = new ModalSet(this.$container,$("#p-column-modal-bg"));
        this.open = new ModalOpen(this.$container,$("#p-column-modal-bg"));
        this.close = new ModalClose(this.$container,$("#p-column-modal-bg"));

        this.current = 0;
        this.prevCurrent = 0; /* [ 手前のやつ保持 ] */

        this.flg = false; /* [ モーダルがオープン状態か ] */
        this.scrollInc = 0; /* [ モーダルをオープンにした際のスクロール位置を保持 ] */
        this.scrollLimit = 0; /* [ モーダルをオープンにした際のスクロール領域の高さを保持 ] */

        this.moveFlg = false;

        this.MAX = 1;

        /* スマホではリストをカルーセルに切り替え */

        this.mode = "pc"; // pc : 普通にリスト表示　| sp : カルーセル
        this.carousel = new ModalListCarousel(this.$list,this.$trigger);



    }
    init(){

        let _this = this;

        this.carousel.init();


        /* -------------------------------------------------------

            --  モーダル内の切り替え

        * ------------------------------------------------------- */

        /* 前後切り替え */
        this.$modalNext.on("click",function(){

            if(_this.moveFlg||$(this).hasClass("is-disable")) return;
            _this.moveFlg = true;

            _this.$modalPrev.removeClass("is-disable");

            if(_this.MAX-1<=_this.current){
                $(this).addClass("is-disable");
            }else{
                $(this).removeClass("is-disable");
            }


            _this.update((_this.MAX>_this.current)?_this.current+1:_this.current,"change");
            _this.change();

        });
        this.$modalPrev.on("click",function(){

            if(_this.moveFlg||$(this).hasClass("is-disable")) return;
            _this.moveFlg = true;

            _this.$modalNext.removeClass("is-disable");

            if(1===_this.current){
                $(this).addClass("is-disable");
            }else{
                $(this).removeClass("is-disable");
            }

            _this.update((0<_this.current)?_this.current-1:_this.current,"change");
            _this.change();

        });


        /* -------------------------------------------------------

            --  モーダルの立ち上げと閉じる

        * ------------------------------------------------------- */

        this.$trigger.on("click",function(){
            if(_this.flg||$(this).hasClass("is-commingsoon")) return;
            let _select = $(this).data("target");

            if(_select==0){
                _this.$modalPrev.addClass("is-disable");
            }else if(_select==this.MAX){
                _this.$modalNext.addClass("is-disable");
            }

            _this.update(_select,"open");

            _this.scrollLimit = $("#l-root").innerHeight();
            TweenMax.set($("#l-root"),{
                "height":$("#p-column-modal .modal-cnt.is-current ").innerHeight(),
                "overflow":"hidden"
            });
            $('html,body').animate({ scrollTop: 0 }, '1');

            if( window.innerWidth<=param.breakpoint ) {
                $("#p-column-modal-contents").remove("style");
            }


            _this.open.start();
        });

        $("#p-column-modal-close").on("click",function(){

            if(!_this.flg) return;

            TweenMax.set($("#l-root"),{
                "height":_this.scrollLimit,
                "overflow":""
            });

            _this.close.start();

            setTimeout(function () {
                _this.update("","close");
            },1e3);

            if( window.innerWidth<=param.breakpoint ) {
                // $('html,body').animate({ scrollTop: 0 }, '1');
            }

        });


        /* -------------------------------------------------------

            --  マウスオンアニメーション　※PCサイズのみ有効

        * ------------------------------------------------------- */

        this.$trigger.on("mouseenter",function(){

            if(_this.mode!=="pc") return;

            let _$def = $(this).find("clipPath path");
            let _hover = $(this).find(".js__hover-path").attr("id");

            animation.svgPathMorph(_$def,["#"+_hover],"normal",0.38);

            TweenMax.to($(this).find(".def-img"),0.6,{
                opacity:0
            });


        }).on("mouseleave",function(){

            if(_this.mode!=="pc") return;

            let _$def = $(this).find("clipPath path");
            let _hover = _$def.attr("id");

            animation.svgPathMorph(_$def,["#"+_hover],"normal",0.38);
            TweenMax.to($(this).find(".def-img"),0.6,{
                opacity:1
            });
        });



    }
    getScrollInc(inc){
        this.scrollInc = inc;
    }
    update(current,type){ /* 状態監視 */

        if(type === "open"||type === "change"){

            if(type==="open"){
                this.flg = true;
                $("#l-root").addClass("is-modal-open");
                this.$container.addClass("is-active");
            }

            this.prevCurrent = this.current;
            this.$modalCnt.removeClass("is-current").removeClass("is-prev-current");
            this.current = current;
            this.$modalCnt.eq(this.current).addClass("is-current");
            this.$modalCnt.eq(this.prevCurrent).addClass("is-prev-current");

            this.$modalPage.find(".current").text("0"+(this.current+1));


        }else{

            let _this = this;

            $("#l-root").removeClass("is-modal-open");
            $('html,body').animate({ scrollTop: this.scrollInc }, '1',function () {
                _this.flg = false;
            });

        }


    }
    /* ---------------------------------------------------

        -- 前後の遷移　アニメーション

    * --------------------------------------------------- */

    change(){

        let _this = this;

        effect.show(_this.$container.find(".modal-cnt.is-prev-current .p-column-illust >*"),"out");
        effect.splitText($(".modal-cnt.is-prev-current .number >* >*,.modal-cnt.is-prev-current .title >* >*"),"out");
        effect.show(_this.$container.find(".modal-cnt.is-prev-current .text"),"out");

        if( window.innerWidth<=param.breakpoint) $('html,body').animate({ scrollTop: $("#p-column-modal-body .modal-cnt").offset().top }, '1');

        setTimeout(function(){

            effect.show(_this.$container.find(".modal-cnt.is-current .p-column-illust >*"),"show");
            effect.splitText($(".modal-cnt.is-current .number >* >*,.modal-cnt.is-current .title >* >*"),"show");
            effect.show(_this.$container.find(".modal-cnt.is-current .text"),"show");

            setTimeout(function(){
                _this.moveFlg = false;
            },2e3);

        },1e3);

    }

    resize(display){

        if( window.innerWidth>param.breakpoint ){
            if(this.mode!=="pc"){
                // this.$trigger.remove("style");
                if(this.flg){
                    this.update("","close");
                    this.close.start();
                    TweenMax.set($("#l-root"),{
                        "height":_this.scrollLimit,
                        "overflow":""
                    });

                }
            }
        }else{
            if(this.mode!=="sp"){

                if(this.flg){
                    // $("#p-column-modal-contents").remove("style");
                    this.update("","close");
                    this.close.start();

                    TweenMax.set($("#l-root"),{
                        "height":_this.scrollLimit,
                        "overflow":""
                    });
                }


            }
        }

        this.mode = display;
        this.carousel.resize(display);




    }




}